
define('app/board/views/selectPlayerEntryView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/collections/pickCollection',
	'known/models/leagueInstanceModel',
	'app/board/models/draftStatusModel',
	'app/board/models/positionColorsModel',
	'app/board/models/pickModel',
	'app/board/util/playerList',
	
	//Templates
	'text!app/board/templates/selectPlayerEntryTemplate.html'
], function($, _, Backbone, PickCollection, LeagueInstanceModel, DraftStatusModel, PositionColorsModel, PickModel, PlayerList, selectPlayerEntryHtml){
	var SelectPlayerEntryView = Backbone.View.extend({
		
		initialize: function(options) {
			this.player = options.player;
			this.draftStatus = options.draftStatus;
			this.leagueInstance = options.leagueInstance;
			this.pickCollection = options.pickCollection;
			this.pickSummaryCollection = options.pickSummaryCollection;
			this.addedPickSumId = options.addedPickSumId;
			this.posColors = options.posColors;
			this.draftStatus = options.draftStatus;
			
			this.rankAttr = 'OVRRANK';
			
			_.bindAll(this, 'draftPlayer');
			_.bindAll(this, 'updatePickSumId');
			
			this.selectPlayerEntryTemplate = _.template(selectPlayerEntryHtml.trim());
			
			this.buildEl();
			
			this.draftStatus.bind("change", this.updateVisuals, this);
			
			this.$(".selectPlayerActions").find('.btn').on('click', {}, this.draftPlayer);
			$(document).on('draftApp:addPickSum', this.updatePickSumId);
		},
		
		render: function () {
			
			
			return this;
		},
		
		buildEl: function() {
			this.setElement($(this.selectPlayerEntryTemplate({
				rank: this.player.attrs && this.player.attrs[this.rankAttr] ? this.player.attrs[this.rankAttr] : 'N/A',
				playerName: this.playerNameText(),
				playerPos: this.player.position,
				teamAbbr: (this.player.byeWeek && this.player.byeWeek > 0) ? this.player.teamAbbr+' '+this.player.byeWeek : this.player.teamAbbr})));
			
			//Hide rank if ranks are turned off
			if(!this.player.attrs){
				this.$(".selectPlayerEntryRankInfo").hide();
			}
			
			var color = this.posColors.retrievePosColor(this.player.position);
			$(this.el).css({'background-color': color});
			
			if(this.leagueInstance.get('id') == 70119 && this.draftStatus.get('round') <= 6 && this.player.drafted){
				this.$(".btn").html('Copy');
			}
			
			this.updateVisuals();
		},
		
		updateVisuals: function() {
			var fantTeamId = this.draftStatus.get('draftingTeamId');
			
			if(this.leagueInstance.get('draftStatus') == 'PREDRAFT'){
				fantTeamId = this.pickSummaryCollection.get(this.addedPickSumId).get('fantasyTeamId');
			}
			
			var allowedPositions = this.draftStatus.get('allowedPositions')[fantTeamId];
			
			if(_.intersection(allowedPositions,this.player.position.split(',')).length > 0){
				this.$(".selectPlayerBtnContainer").show();
			} else {
				this.$(".selectPlayerBtnContainer").hide();
			}
			
			//Hide these buttons if they're bidding
			if(this.leagueInstance.get('draftStatus') == 'STARTED' && this.leagueInstance.get('draftType') == 'AUCTION' && this.draftStatus.get('auctionBidding')){
				this.$(".selectPlayerBtnContainer").hide();
			}
		},
		
		playerNameText: function() {
			var dispName = this.player.lastName;
			
			if(this.player.firstName){
				dispName += ', ' + this.player.firstName;
			}
			
			return dispName; 
		},
		
		updatePickSumId: function(event, pickSumId) {
			this.addedPickSumId = pickSumId;
			this.updateVisuals();
		},
		
		draftPlayer: function() {
			var round = this.draftStatus.get('round');
			var posInRound = this.draftStatus.get('posInRound');
			var fantTeamId = this.draftStatus.get('draftingTeamId');
			var keeper = false;
			var autoDrafted = false;
			var value = 0;
			
			if(this.leagueInstance.get('draftStatus') == 'PREDRAFT' && this.leagueInstance.get('draftType') == 'AUCTION'){
				var pickSum = this.pickSummaryCollection.get(this.addedPickSumId);
				var team = this.leagueInstance.getTeam(pickSum.get('fantasyTeamId'));
				fantTeamId = pickSum.get('fantasyTeamId');
				keeper = true;
				value = 1; //TODO: Add a value input to the popup for keepers
				
				var nextKeeperPosRoundId = this.pickSummaryCollection.getNextPosRoundAuctionKeeperId(fantTeamId);
				posInRound = nextKeeperPosRoundId % 1000;				
				round = Math.ceil(nextKeeperPosRoundId / 1000.0);
			} else if(this.leagueInstance.get('draftStatus') == 'PREDRAFT'){
				var pickSum = this.pickSummaryCollection.get(this.addedPickSumId);
				round = pickSum.get('round');
				posInRound = pickSum.get('posInRound');
				fantTeamId = pickSum.get('fantasyTeamId');
				keeper = true;
			}
			
			if(this.leagueInstance.get('id') == 70119 && this.draftStatus.get('round') <= 6 && this.player.drafted){
				var dataObj = {
						firstName: this.player.firstName,
						lastName: this.player.lastName,
						teamAbbr: this.player.teamAbbr,
						position: this.player.position,
						fantasyTeamId: fantTeamId,
						round: round,
						posInRound: posInRound,
						keeper: keeper};
				
				$.ajax({
					headers : {
						"Content-Type" : "application/json",
						"Accept" : "application/json"
					},
					url : '/draftapp/leagues/' 
						+ this.leagueInstance.get('leagueId') 
						+ '/league-instances/' 
						+ this.leagueInstance.get('id')
						+ '/picks/new',
					type : 'POST',
					dataType : 'json',
					//accepts: 'application/json',
					//contentType: 'application/json',
					data : JSON.stringify(dataObj, null, 2),
					success: this.successCallback,
					error: this.errorCallback
				});
				
				$('.draftPlayerTrigger').first().dropdown('toggle');
				return this;
			}
			
			if(this.leagueInstance.get('draftType') == 'AUCTION') {
				var valueInput = $('#draftPlayerBidInput').val();
				var numPattern = new RegExp("^[0-9]*$");
				
				if(!valueInput){
					valueInput = 1;
				} else if(valueInput && valueInput.length == 0){
					valueInput = 1; 
				} else if(!valueInput.match(numPattern)){
					$('#draftPlayerBidErrMsg').html("Bid field may only contain numbers");
					$('#draftPlayerBidInput').addClass("error");
					$('#draftPlayerBidErrMsg').show();
					return this;
				} else {
					valueInput = parseInt(valueInput);
				}				
				
				var curBudget = this.draftStatus.get('teamBudget')[fantTeamId];
				var playersPicked = this.draftStatus.get('teamPickCount')[fantTeamId];
				var maxPlayers = this.draftStatus.get('teamMaxNumPicks')[fantTeamId];
				var maxBid = curBudget-(maxPlayers-playersPicked)+1;
				
				if(valueInput > maxBid) {
					$('#draftPlayerBidErrMsg').html("Bid is higher then max bid");
					$('#draftPlayerBidInput').addClass("error");
					$('#draftPlayerBidErrMsg').show();
					return this;
				} else if(valueInput < 1){
					$('#draftPlayerBidErrMsg').html("Bid must be at least 1");
					$('#draftPlayerBidInput').addClass("error");
					$('#draftPlayerBidErrMsg').show();
					return this;
				} else if(valueInput > 999) {
					$('#draftPlayerBidErrMsg').html("Bid must be less then 1000");
					$('#draftPlayerBidInput').addClass("error");
					$('#draftPlayerBidErrMsg').show();
					return this;
				}
				
				value = valueInput;
			}
			
			var newPick = new PickModel({
				leagueId : this.leagueInstance.get('leagueId'),
				leagueInstanceId : this.leagueInstance.get('id'),
				fantasyTeamId : fantTeamId,
				draftablePlayerId : this.player.draftablePlayerId,
				value : value,
				posInRound: posInRound,
				round : round,
				keeper : keeper,
				autoDrafted : autoDrafted});
			
			newPick.save();
			
			$('.draftPlayerTrigger').first().dropdown('toggle');
		},
		
		destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        }
	});
	
	return SelectPlayerEntryView;  
});